import { render, staticRenderFns } from "./VExpenses.vue?vue&type=template&id=447801c2&"
import script from "./VExpenses.vue?vue&type=script&lang=js&"
export * from "./VExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports